/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Batch Subtitle Export" |
*
* @param {Batch_Subtitle_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_title = /** @type {((inputs?: Batch_Subtitle_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lot de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapel-Untertitelexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione batch di sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de subtítulos por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕の一括エクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच उपशीर्षक निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote de legendas")
	return /** @type {LocalizedString} */ ("Batch Subtitle Export")
});